/**
 * I-2602 (`docs/concept-decisions-and-questions.md`, TF-36 to TF-38): what makes a task stand out
 * among those waiting for the reader. Only urgent and high are named; medium, low and an unset
 * priority are the ordinary run of the list and say nothing.
 */
export type PressingPriorityType = 'urgent' | 'high';

/** The task's priority when it is one a reader must see at a glance, or `null`. */
export function pressingPriority(priority?: string | null): PressingPriorityType | null {
  return priority === 'urgent' || priority === 'high' ? priority : null;
}

/** How many of `tasks` are urgent: the count's urgent part (TF-38). */
export function urgentCountOf(tasks: readonly { item: { priority?: string | null } }[]): number {
  return tasks.filter((task) => task.item.priority === 'urgent').length;
}

const PRESSURE: Record<PressingPriorityType, number> = { urgent: 0, high: 1 };
const ORDINARY = 2;

/**
 * TF-37: how pressing a group of tasks is, for ordering groups: 0 with an urgent row, 1 with a high
 * one, 2 otherwise (medium, low and no priority are all ordinary). Equals keep their order.
 */
export function groupPressure(tasks: readonly { item: { priority?: string | null } }[]): number {
  return tasks.reduce((rank, task) => {
    const pressing = pressingPriority(task.item.priority);
    return Math.min(rank, pressing ? PRESSURE[pressing] : ORDINARY);
  }, ORDINARY);
}
